import React, { FC, ReactNode } from "react";
import { FormControl, FormErrorMessage } from "@UI/Components/Form/Form";
import { BaseQuestionProps } from "../types";

export interface QuestionFormControlProps extends BaseQuestionProps {
  children: ReactNode;
}

/**
 * Shared FormControl/FormErrorMessage shell every question component wraps its
 * fields in, so the isRequired/isInvalid/errorMessage contract stays identical
 * across question types instead of being reimplemented in each one.
 *
 * isDisabled is forwarded to FormControl (not just the inner control) because
 * Chakra's FormLabel theme only dims to 40% opacity via its own `_disabled` style
 * when FormControl itself carries isDisabled — passing it solely to the Radio/
 * Checkbox/Input leaves the label looking enabled even though the field isn't.
 */
export const QuestionFormControl: FC<QuestionFormControlProps> = ({
  children,
  isRequired = false,
  isInvalid = false,
  errorMessage = "",
  isDisabled = false,
}) => (
  <FormControl isRequired={isRequired} isInvalid={isInvalid} isDisabled={isDisabled}>
    {children}
    {isInvalid && <FormErrorMessage>{errorMessage}</FormErrorMessage>}
  </FormControl>
);
